export const CLEAR_FINETUNE = 'CLEAR_FINETUNE';

const clearFinetune = (state, { finetune, defaultProps = {} }) => {
  const nextProps = { ...state.finetunesProps };

  Object.entries(defaultProps).forEach(([key, value]) => {
    nextProps[key] = value;
  });

  return {
    ...state,
    isDesignState: true,
    finetunes: finetune
      ? state.finetunes.filter((fn) => fn !== finetune)
      : state.finetunes,
    finetunesProps: nextProps,
  };
};

export default clearFinetune;
